"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleCalculator = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
class VehicleCalculator {
    static calculateCapacityOfVehicles(vehicles) {
        return vehicles.reduce((sum, vehicleTypeId) => sum + legacy_enums_1.VehicleTypesCapacity[vehicleTypeId], 0);
    }
}
exports.VehicleCalculator = VehicleCalculator;
//# sourceMappingURL=VehicleCalculator.js.map